import { createFileRoute } from "@tanstack/react-router";
import Resposta from "@/pages/admin/Resposta";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/admin/formularios/$tipo/$respostaId")({
  head: () => pageHead({ title: "Resposta | Painel", path: "/admin/formularios", noindex: true }),
  component: Resposta,
});
